import { useSelector } from "react-redux"

function ResultStaffPercent(){
    const ResultKashier = useSelector(state => state.StaffSlice.ResultKashier)
    const ResultCook = useSelector(state => state.StaffSlice.ResultCook)
    const ResultCookSecondGroup = useSelector(state => state.StaffSlice.ResultCookSecondGroup)
    const ResultManager = useSelector(state => state.StaffSlice.ResultManager)
    const ResultOther = useSelector(state => state.StaffSlice.ResultOther)
    const ResultFOT = useSelector(state => state.StaffSlice.ResultFOT)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)

    const Period = useSelector(state => state.PeriodSlice.Period)

    return(
        <div
        className="FontWeightFat"
        >

            {/*Касса*/}
            <div
            className="StaffPercentMainDiv Margin"
            >
                {Period.MinDay < 14 && 
                <div
                className="RevenueCityLongDiv"
                >
                Итого касса %
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultKashier.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                        
                    </div>
                )}
                   
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 && 
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                        
                        {Period.MinDay < 14 && 
                        <div
                         className="RevenueTotalDiv"
                        >
                            {((ResultKashier.FirstTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}
                        </div>
                        }
                                            
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                        className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                    </div>
                    {Period.MaxDay > 15 && 
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого касса %
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultKashier.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                />
                }

                
                {Period.MaxDay > 15 &&
                <div
                className="RevenueTotalDiv"
                >
                     {((ResultKashier.SecondTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}
                </div>
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                     {((ResultKashier.TotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? SumRevenue + parseFloat(itemRevenue.Value) 
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}
                </div>
                }
            </div>

            {/*Повара 1 группа*/}

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 && 
                <div
                className="RevenueCityLongDiv"
                >
                Итого повара (группа 1) %
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultCook.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}
                    
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                                                
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {((ResultCook.FirstTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}                            
                        </div>
                        }

                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        

                    </div>
                    {Period.MaxDay > 15 && 
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого повара (группа 1) %
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultCook.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}

                        {Period.MaxDay > 15 && 
                        <div
                        className="RevenueTotalDiv"
                        />
                        }

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultCook.SecondTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}  
                </div>
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultCook.TotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? SumRevenue + parseFloat(itemRevenue.Value)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}  
                </div>
                }
            </div>

            {/*Повара 2 группа*/}

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 && 
                <div
                className="RevenueCityLongDiv"
                >
                Итого повара (группа 2) %
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultCookSecondGroup.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}
                    
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                                                
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {((ResultCookSecondGroup.FirstTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}                            
                        </div>
                        }

                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        

                    </div>
                    {Period.MaxDay > 15 && 
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого повара (группа 2) %
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultCookSecondGroup.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}

                        {Period.MaxDay > 15 && 
                        <div
                        className="RevenueTotalDiv"
                        />
                        }

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultCookSecondGroup.SecondTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}  
                </div>
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultCookSecondGroup.TotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? SumRevenue + parseFloat(itemRevenue.Value)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}  
                </div>
                }
            </div>
                       
            {/*Управы*/}

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого управление %
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultManager.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                        
                    </div>
                )}
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                        
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {((ResultManager.FirstTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}                           
                        </div>
                        }


                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                        className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        
                    </div>
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого управление %
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay && 
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultManager.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}

                        {Period.MaxDay > 15 && 
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                
                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultManager.SecondTotalSum / 
                        (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                            (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                : SumRevenue, 0
                            ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                        ).toFixed(2).replace('.', ',') + "%"}  
                </div>
                }                    
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultManager.TotalSum / 
                        (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                            (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                ? SumRevenue + parseFloat(itemRevenue.Value) 
                                : SumRevenue, 0
                            ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                        ).toFixed(2).replace('.', ',') + "%"}  
                </div>
                }
            </div>

           {/*Без %>*/}

           <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого кухрабочие и стажеры %
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultOther.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}
                    
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                                                
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {((ResultOther.FirstTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}   
                        </div>
                        }                       
                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }                        

                    </div>
                
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого кухрабочие и стажеры %
                    </div>
                    }
                
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultOther.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}

                        {Period.MaxDay > 15 && 
                        <div
                        className="RevenueTotalDiv"
                        />
                        }

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultOther.SecondTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}   
                </div>
                }             
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultOther.TotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? SumRevenue + parseFloat(itemRevenue.Value)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}   
                </div>
                }
            </div>

            {/*Итого*/}
            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого ФОТ %
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                       {(parseFloat(ResultFOT.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                        
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {((ResultFOT.FirstTotalSum / 
                                (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                                (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                                    ? (itemRevenue.id < 15 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                                    : SumRevenue, 0
                                ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                            ).toFixed(2).replace('.', ',') + "%"}                               
                        </div>
                        }
                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        

                    </div>
                        
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого ФОТ %
                    </div>
                    }

                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay && 
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {(parseFloat(ResultFOT.Result[el.id]) / (parseFloat(el.Value) * (parseFloat(PercentCity.RatioRevenue) / 100) / 100)).toFixed(2).replace('.', ',') + "%"}
                    </div>
                )}

                {Period.MaxDay > 15 &&
                <div
                className="RevenueTotalDiv"
                >

                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultFOT.SecondTotalSum / 
                        (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                        (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                        ? (itemRevenue.id > 14 ? SumRevenue + parseFloat(itemRevenue.Value) : SumRevenue)
                        : SumRevenue, 0
                        ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                    ).toFixed(2).replace('.', ',') + "%"}   
                </div>
                }
                


                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                >
                </div>
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {((ResultFOT.TotalSum / 
                        (RevenueArray.reduce((SumRevenue, itemRevenue) => 
                            (itemRevenue.id > Period.MinDay && itemRevenue.id < Period.MaxDay)
                            ? SumRevenue + parseFloat(itemRevenue.Value)
                            : SumRevenue, 0
                        ) * (parseFloat(PercentCity.RatioRevenue) / 100))) * 100
                    ).toFixed(2).replace('.', ',') + "%"}   
                </div>
                }
            </div>
                       
        </div>
    )
}

export default ResultStaffPercent